import { render } from "./hero-chapters.vue?vue&type=template&id=3a2b5112&ts=true"
import script from "./hero-chapters.vue?vue&type=script&lang=ts"
export * from "./hero-chapters.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__